<template>
    <div class="grid grid-cols-1 md:col-span-2 lg:grid-cols-10 gap-3 mt-3">
        <div class="flex flex-col md:col-span-2 lg:col-span-5">
            <Field field_name="Titolo" :required="!sottoprogetto_model?.titolo?.length"
                   v-model="sottoprogetto_model.titolo"
                   placeholder="Nome del sottoprogetto" :errors="getErrors('titolo')"></Field>
        </div>
        <!--        <div class="flex flex-col lg:col-span-2">-->
        <!--            <Field field_name="Codice Nodo" :required="true" v-model="sottoprogetto_model.codice_nodo"-->
        <!--                   placeholder="Codice nodo" :errors="getErrors('codice_nodo')"></Field>-->
        <!--        </div>-->
        <div class="flex flex-col lg:col-span-5">
            <Field field_name="Business Unit" :required="!buAutocomplete?.selection" placeholder="Codice commessa"
                   :errors="getErrors('business_unit_id')">
                <VueMultiselect :searchable="true" :loading="buAutocomplete.isLoading"
                                :internal-search="true"
                                trackBy="id"
                                label="label"
                                v-model="buAutocomplete.selection"
                                :options="buAutocomplete.options"
                                :multiple="false"
                                class="next-vue-multiselect-single"
                                :close-on-select="true" :clear-on-select="true"
                                placeholder="Business Unit"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                >
                    <template v-slot:tag="{option, remove}">
                            <span
                                class="relative inline-block p-2 border border-next-neu hover:border-next-orange group mr-2 mb-2">
                                <span class="mr-2">{{ option.label }}</span>
                                <i tabindex="1" @click.stop.prevent="remove(option)"
                                   class="cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"></i>
                            </span>
                    </template>
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-4">
            <Field field_name="Data di inizio" :required="!sottoprogetto_model?.data_inizio"
                   :errors="getErrors('data_inizio')"
                   :input-attrs="{max:sottoprogetto_model.data_fine}"
                   placeholder="Data di inizio" type="date" v-model="sottoprogetto_model.data_inizio">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-4">
            <Field field_name="Data di fine" :required="!sottoprogetto_model?.data_fine"
                   :errors="getErrors('data_fine')"
                   :input-attrs="{min:sottoprogetto_model.data_inizio}"
                   placeholder="Data di fine" type="date" v-model="sottoprogetto_model.data_fine">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Anno" :required="!sottoprogetto_model?.anno" v-model="sottoprogetto_model.anno"
                   :errors="getErrors('anno')"
                   placeholder="Anno">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Budget di apertura" :required="!sottoprogetto_model?.budget"
                   v-model="sottoprogetto_model.budget" type="number"
                   :input-attrs="{step:.01}"
                   :errors="getErrors('budget')" placeholder="Budget">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Tipo operazione" :required="!tipoOperazioniAutocomplete?.selection"
                   :errors="getErrors('tipo_operazione_id')" placeholder="Tipo operazione">
                <VueMultiselect v-model="tipoOperazioniAutocomplete.selection"
                                :options="tipoOperazioniAutocomplete.options"
                                track_by="id" label="descrizione"
                                placeholder="Tipo evento"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                @search-change="tipoOperazioniAutocomplete.search"
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Tipo di IVA" :required="!tipo_iva_selection"
                   :errors="getErrors('tipo_iva')" placeholder="Tipo di IVA">
                <VueMultiselect v-model="tipo_iva_selection"
                                :options="tipo_iva_options"
                                track_by="id" label="label"
                                placeholder="Tipo iva"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-4">
            <Field field_name="Descrizione" v-model="sottoprogetto_model.descrizione"
                   :errors="getErrors('descrizione')" placeholder="Descrizione">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Gara"
                   :required="!gara_selection"
                   :errors="getErrors('gara')" placeholder="Gara">
                <VueMultiselect v-model="gara_selection"
                                :options="si_no_options"
                                track_by="id" label="label"
                                placeholder="Gara"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Data di arrivo Brief" :required="!sottoprogetto_model?.data_arrivo"
                   :errors="getErrors('data_arrivo')"
                   v-model="sottoprogetto_model.data_arrivo" type="date">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Data consegna Progetto/Offerta" :required="!sottoprogetto_model?.data_consegna"
                   :errors="getErrors('data_consegna')"
                   v-model="sottoprogetto_model.data_consegna" type="date">
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Ipotesi data di aggiudicazione" :required="false"
                   v-model="sottoprogetto_model.ipotesi_data_aggiudicazione" type="date"
                   :errors="getErrors('ipotesi_data_aggiudicazione')">
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-4">
            <Field field_name="&nbsp" :errors="getErrors('new_business')">
                <Checkbox
                    checkClass="h-4 w-4"
                    :checked="sottoprogetto_model.new_business"
                    @change="sottoprogetto_model.new_business = $event.target.checked"
                >
                    Progetto New Business
                </Checkbox>
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-6">
            <Field field_name="Sottoprogetto intragruppo">
                <VueMultiselect
                    ref="select"
                    :disabled="!canSetIntragruppo"
                    :internal-search="false"
                    :close-on-select="true"
                    :clear-on-select="true"
                    class="next-vue-multiselect-single"
                    placeholder="Sottoprogetto"
                    deselectLabel="Deseleziona"
                    selectedLabel="Selezionato"
                    selectLabel="Seleziona"
                    label="cod_nodo"
                    :options="sottoprogettoAutocomplete.options"
                    @search-change="sottoprogettoAutocomplete.search"
                    v-model="sottoprogettoAutocomplete.selection">
                    <template v-slot:option="{option}">
                                    <span class="text-sm flex flex-col whitespace-normal">
                                        <span>Cod: {{ option.cod_nodo }}</span>
                                        <span>BU: {{ option.bu_label }}</span>
                                        <span>Titolo: {{ option.titolo }}</span>
                                    </span>
                    </template>
                </VueMultiselect>
            </Field>
        </div>

        <div class="md:col-span-2 lg:col-span-4">
            <p class="font-bold">Head of Client / Client Director</p>
            <ul v-show="accounts_cliente.length" class="pl-3 list-disc">
                <li v-for="a in accounts_cliente">
                    {{ a.name }}
                </li>
            </ul>
            <p v-show="!accounts_cliente.length">Nessun utente presente per la bu scelta</p>
        </div>
        <div class="flex flex-col lg:col-span-6">
            <Field field_name="Account Gestionale" :required="!accountAutocomplete?.selection?.length"
                   :errors="getErrors('accounts')">
                <VueMultiselect v-model="accountAutocomplete.selection" :options="accountAutocomplete.options"
                                :multiple="true"
                                @search-change="accountAutocomplete.search"
                                :close-on-select="false" :clear-on-select="false"
                                placeholder="Accounts"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                tagPlaceholder="Aggiungi account"
                                class="next-vue-multiselect"
                                track-by="id" label="name">
                    <template v-slot:noResult>Nessun elemento trovato.</template>
                    <template v-slot:tag="{option, remove}">
                        <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                            <span>{{ option.name }}</span>
                        </MultiselectOption>
                    </template>

                    <template v-slot:option="{option}">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                    </template>
                </VueMultiselect>
            </Field>
        </div>


        <div class="flex flex-col lg:col-span-4">
            <Field field_name="PM" :errors="getErrors('project_managers')">
                <VueMultiselect v-model="projectManagersAutocomplete.selection"
                                :options="projectManagersAutocomplete.options"
                                :multiple="true"
                                :disabled="sottoprogetto_model.pm_esterno"
                                @search-change="projectManagersAutocomplete.search"
                                :close-on-select="false" :clear-on-select="false"
                                placeholder="Project Managers"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                tagPlaceholder="Aggiungi PM"
                                class="next-vue-multiselect"
                                track-by="id" label="name">
                    <template v-slot:noResult>Nessun elemento trovato.</template>
                    <template v-slot:tag="{option, remove}">
                        <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                            <span>{{ option.name }}</span>
                        </MultiselectOption>
                    </template>

                    <template v-slot:option="{option}">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                    </template>
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col">
            <Field field_name="Esterno" :required="false"
                   :errors="getErrors('pm_esterno')">
                <Checkbox
                    checkClass="h-4 w-4"
                    :checked="sottoprogetto_model.pm_esterno"
                    @change="sottoprogetto_model.pm_esterno = !sottoprogetto_model.pm_esterno"
                    for_id="pm_esterno">
                </Checkbox>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-4">
            <Field field_name="Produzione" :errors="getErrors('produzione')">
                <VueMultiselect v-model="direttoriProduzioneAutocomplete.selection"
                                :options="direttoriProduzioneAutocomplete.options"
                                :multiple="true"
                                @search-change="direttoriProduzioneAutocomplete.search"
                                :disabled="sottoprogetto_model.produzione_esterna"
                                :close-on-select="false" :clear-on-select="false"
                                placeholder="Produzione"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                tagPlaceholder="Aggiungi direttore"
                                class="next-vue-multiselect"
                                track-by="id" label="name">
                    <template v-slot:noResult>Nessun elemento trovato.</template>
                    <template v-slot:tag="{option, remove}">
                        <MultiselectOption @remove="remove(option)">
                                    <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                        {{ option.bu_label || '&nbsp;' }}</span>
                            <span>{{ option.name }}</span>
                        </MultiselectOption>
                    </template>

                    <template v-slot:option="{option}">
                            <span>
                                <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                <span class="ml-2">{{ option.name }}</span>
                            </span>
                    </template>
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col">
            <Field field_name="Esterno" :required="false"
                   :errors="getErrors('produzione_esterna')">
                <Checkbox
                    checkClass="h-4 w-4"
                    :checked="sottoprogetto_model.produzione_esterna"
                    @change="sottoprogetto_model.produzione_esterna = !sottoprogetto_model.produzione_esterna"
                    for_id="produzione_esterna">
                </Checkbox>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Paese" :required="false" v-model="sottoprogetto_model.destinazione"
                   :errors="getErrors('destinazione')" placeholder="Paese">
                <VueMultiselect v-model="paeseAutocomplete.selection"
                                :options="paeseAutocomplete.options"
                                @search-change="paeseAutocomplete.search"
                                :close-on-select="true" :clear-on-select="true"
                                placeholder="Paese"
                                deselectLabel="Deseleziona"
                                selectedLabel="Selezionato"
                                selectLabel="Seleziona"
                                class="next-vue-multiselect-single"
                                track-by="id" label="nome">
                    <template v-slot:noResult>Nessun elemento trovato.</template>
                </VueMultiselect>
            </Field>
        </div>
        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Città" :required="false" v-model="sottoprogetto_model.citta" type="text"
                   :errors="getErrors('citta')" placeholder="Città">
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Segreteria" :required="false"
                   :errors="getErrors('segreteria')" placeholder="Segreteria">
                <VueMultiselect v-model="segreteria_selection"
                                :options="si_no_options"
                                track_by="id" label="label"
                                placeholder="Segreteria"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Tipo di evento" :required="false"
                   :errors="getErrors('tipo_evento')" placeholder="Tipo di evento">
                <VueMultiselect v-model="tipo_evento_selection"
                                :options="tipo_evento_options"
                                track_by="id" label="label"
                                placeholder="Tipo evento"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Biglietteria" :required="false"
                   :errors="getErrors('biglietteria')" placeholder="Biglietteria">
                <VueMultiselect v-model="biglietteria_selection"
                                :options="si_no_options"
                                track_by="id" label="label"
                                placeholder="Biglietteria"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-3">
            <Field field_name="Periodicità" :required="requiredPeriodicita"
                   :errors="getErrors('periodicita')" placeholder="Periodicità">
                <VueMultiselect v-model="periodicita_selection"
                                :options="periodicita_options"
                                track_by="id" label="label"
                                placeholder="Periodicità"
                                deselectLabel=""
                                selectedLabel=""
                                selectLabel=""
                                :close-on-select="true" :clear-on-select="true"
                                class="next-vue-multiselect-single">
                </VueMultiselect>
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-2">
            <Field field_name="Numero Pax" :required="false"
                   :errors="getErrors('numero_pax')" v-model="sottoprogetto_model.numero_pax">
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-2">
            <Field field_name="CIG" :required="false"
                   :errors="getErrors('cig')" v-model="sottoprogetto_model.cig">
            </Field>
        </div>

        <div class="flex flex-col lg:col-span-10 col-span-2">
            <Field field_name="Note" :required="false" :errors="getErrors('note')">
                        <textarea v-model="sottoprogetto_model.note"
                                  class="bg-next-gray-md hover:bg-white p-2 h-full w-full"
                                  placeholder="Note"/>
            </Field>
        </div>

        <!--        <div class="flex flex-col justify-end lg:col-span-3">-->
        <!--            <Field field_name="&nbsp;" :errors="getErrors('assets')">-->
        <!--                <FileUpload-->
        <!--                    v-model:uploaded_files="uploaded_files"-->
        <!--                    v-model:model_files="sottoprogettoFiles"-->
        <!--                    v-model:to_delete="to_delete"-->
        <!--                    multiple-->
        <!--                    accept=".csv,.txt,.xlx,.xls,.pdf"-->
        <!--                >-->
        <!--                    <template v-slot:default="{props, methods}">-->
        <!--                        <div class="flex flex-col grow">-->
        <!--                            <NextButton variant="outline-secondary" @click="methods.open"-->
        <!--                                        class="w-full h-10 px-4 grow">-->
        <!--                                <i class="icon icon-graffetta"></i> Allega-->
        <!--                            </NextButton>-->
        <!--                            <div class="grid grid-cols-1 gap-3">-->
        <!--                                <a class="underline text-sm text-next-atp pt-3"-->
        <!--                                   v-for="(f,idx) in sottoprogettoFiles">-->
        <!--                                    <span>{{ f.name }}</span>-->
        <!--                                    <i v-if="!$attrs.readonly"-->
        <!--                                       class="icon icon-x ml-1"-->
        <!--                                       @click="methods.remove(idx)"></i>-->
        <!--                                </a>-->

        <!--                                <a class="underline text-sm text-next-atp pt-3"-->
        <!--                                   v-for="(f,idx) in props.to_upload">-->
        <!--                                    <span>{{ f.name }}</span>-->
        <!--                                    <i v-if="!$attrs.readonly"-->
        <!--                                       class="icon icon-x ml-1"-->
        <!--                                       @click="methods.remove(idx)"></i>-->
        <!--                                </a>-->

        <!--                                <a class="underline text-sm text-next-atp pt-3"-->
        <!--                                   v-for="(f,idx) in uploaded_files">-->
        <!--                                    <span>{{ f.name }}</span>-->
        <!--                                    <i v-if="!$attrs.readonly"-->
        <!--                                       class="icon icon-x ml-1"-->
        <!--                                       @click="methods.remove(idx)"></i>-->
        <!--                                </a>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </template>-->
        <!--                </FileUpload>-->
        <!--            </Field>-->
        <!--        </div>-->

        <div class="flex items-end grid grid-cols-2 lg:col-start-7 lg:col-span-4">
            <NextButton variant="outline-secondary"
                        @click="$emit('chiudi')"
                        class="px-4 grow mr-1 h-10">
                Chiudi
            </NextButton>
            <NextButton variant="primary" @click="creaSottoProgetto" :disabled="loading" :loading="loading"
                        class="grow ml-1 h-10 flex items-center justify-center">
                <Spinner v-show="loading" class="w-4 h-4 mr-4"></Spinner>
                {{ create ? 'Aggiungi' : 'Salva' }}
            </NextButton>
        </div>
    </div>

</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import {aziendeGruppoBuManager} from "@/api/AziendeGruppo";
import userManager from "../api/Users";
import sottoProgettiManager from "../api/SottoProgetti";
import progettiManager from "../api/Progetti";
import MultiselectOption from "@/components/MultiselectOption.vue";
import NextButton from "@/components/NextButton.vue";
import Field from "@/components/Field.vue";
import tipoOperazioniManager from "../api/TipoOperazioni";
import FileUpload from "@/components/FileUpload.vue";
import Checkbox from "@/components/Checkbox.vue";
import {nazioneManager} from "@/api/Citta";
import Spinner from "@/components/Spinner.vue";
import {mapGetters} from "vuex";
import clientiManager from "../api/Clienti";
import clienti from "../api/Clienti";

@Options({
    name: 'SottoProgettoForm',
    components: {
        Spinner,
        Checkbox,
        Field,
        NextButton,
        FileUpload,
        MultiselectOption,
    },
    props: {
        defaultValue: {
            type: Object,
            default: null
        },
        cliente_id: {
            type: [Number, String],
            required: false
        },
        visible: {
            type: Boolean,
            default: true
        },
        id: {
            type: [Number, String],
            default: 0
        },
        progetto_id: {
            type: [Number, String],
            default: 0
        },
        progetto_is_promo: {
            type: Boolean,
            default: false
        },
        create: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ])
    },
})
export default class SottoProgettoForm extends Vue {

    id!: number | string
    hasPermission!: (perm: string) => boolean
    progetto_id!: number | string
    visible!: boolean
    create!: boolean
    defaultValue!: any
    progetto_is_promo!: boolean
    loading = false
    cliente_id!: number | string

    accounts_cliente = []

    progetto_model!: any

    sottoprogetto_model: any = {
        titolo: null,
        codice_nodo: null,
        tipo_iva: 0,
        tipo_evento: null,
        numero_pax: null,
        destinazione: null,
        anno: null,
        biglietteria: null,
        gara: null,
        periodicita: null,
        tipo_operazione_id: null,
        segreteria: null,
        descrizione: null,
        data_inizio: null,
        data_fine: null,
        data_arrivo: null,
        data_consegna: null,
        ipotesi_data_aggiudicazione: null,
        business_unit_id: null,
        data_consegna_offerta: null,
        note: null,
        budget: null,
        pm_esterno: false,
        citta: null,
        cig: null,
        produzione_esterna: false,
        budget_preventivo: null,
        accounts: [],
        project_managers: [],
        direttori_produzione: [],
        files_ids: null,
        paese_id: null,
        new_business: false,
    }

    // uploaded_files: any[] = []
    // sottoprogettoFiles: any[] = []
    // to_delete: number[] = []


    tipo_iva_options = [
        {id: 0, label: 'Ordinaria'},
        {id: 1, label: '74Ter'}
    ]
    tipo_iva_selection: any | undefined = this.tipo_iva_options[0]

    tipo_evento_options = [
        {id: 0, label: 'Live'},
        {id: 1, label: 'Ibrido'},
        {id: 2, label: 'Digitale'}
    ]
    tipo_evento_selection: any = null

    periodicita_options = [
        {id: 0, label: 'Una tantum'},
        {id: 1, label: 'Ricorsivo'},
    ]
    periodicita_selection: any = null

    si_no_options = [
        {id: false, label: 'No'},
        {id: true, label: 'Sì'},
    ]

    created() {
        // if(Environment.isDev && false){
        //     this.sottoprogetto_model.titolo =  'asds',
        //     this.sottoprogetto_model.tipo_iva =  0,
        //     this.sottoprogetto_model.tipo_evento =  0,
        //     this.sottoprogetto_model.numero_pax =  0,
        //     this.sottoprogetto_model.destinazione =  null,
        //     this.sottoprogetto_model.anno =  2022,
        //     this.sottoprogetto_model.data_inizio =  '2022-01-01',
        //     this.sottoprogetto_model.data_fine =  '2022-01-01',
        //     this.sottoprogetto_model.data_arrivo =  '2022-01-01',
        //     this.sottoprogetto_model.data_arrivo =  '2022-01-01',
        //     this.sottoprogetto_model.data_consegna = '2022-01-01',
        //     this.sottoprogetto_model.ipotesi_data_aggiudicazione = '2022-01-01',
        //     this.sottoprogetto_model.business_unit_id =  0,
        //     this.sottoprogetto_model.data_consegna_offerta =  '2022-01-01',
        //     this.sottoprogetto_model.budget =  123,
        //     this.sottoprogetto_model.budget_preventivo =  123,
        //     this.sottoprogetto_model.accounts =  [1]
        // }
        if (this.defaultValue) {
            this.sottoprogetto_model = {...this.sottoprogetto_model, ...this.defaultValue}
        }
        this.paeseAutocomplete.search('', 0)
        if (this.defaultValue?.azienda_gruppo_id) {
            this.buAutocomplete.callBinds = [this.defaultValue.azienda_gruppo_id]
            this.buAutocomplete.search('', 0)
        }
        if (this.progetto_is_promo) {
            this.tipoOperazioniAutocomplete.addAjaxParam('s', 1)
        }
    }

    mounted() {
        this.reload()
    }

    biglietteria_selection: any = null
    gara_selection: any = null
    segreteria_selection: any = null

    buAutocomplete: any = setup(() => Autocomplete(aziendeGruppoBuManager, false, {crm: 1}))
    accountAutocomplete: any = setup(() => Autocomplete(userManager, true))
    projectManagersAutocomplete: any = setup(() => Autocomplete(userManager, true))
    direttoriProduzioneAutocomplete: any = setup(() => Autocomplete(userManager, true))
    paeseAutocomplete: any = setup(() => Autocomplete(nazioneManager))
    tipoOperazioniAutocomplete: any = setup(() => Autocomplete(tipoOperazioniManager))
    sottoprogettoAutocomplete: any = setup(() => Autocomplete(sottoProgettiManager, false))


    reload() {
        if (this.id) {
            sottoProgettiManager.sottoprogetto(this.id).then((response) => {
                this.sottoprogetto_model = {...this.sottoprogetto_model, ...response.data}
                this.paeseAutocomplete.retrieve(this.sottoprogetto_model.paese_id)
                this.sottoprogettoAutocomplete.retrieve(this.sottoprogetto_model.intragruppo_padre_id)
                // sottoProgettiManager.briefFiles(this.id).then((response) => {
                //     this.sottoprogettoFiles = response.data
                // })

                this.segreteria_selection = this.si_no_options.find((el) => {
                    return el.id == this.sottoprogetto_model.segreteria
                })
                this.biglietteria_selection = this.si_no_options.find((el) => {
                    return el.id == this.sottoprogetto_model.biglietteria
                })

                this.gara_selection = this.si_no_options.find((el) => {
                    return el.id == this.sottoprogetto_model.gara
                })

                this.periodicita_selection = this.periodicita_options.find((el) => {
                    return el.id == this.sottoprogetto_model.periodicita
                })

                this.tipo_iva_selection = this.tipo_iva_options.find((el) => {
                    return el.id == this.sottoprogetto_model.tipo_iva
                })

                this.tipo_evento_selection = this.tipo_evento_options.find((el) => {
                    return el.id == this.sottoprogetto_model.tipo_evento
                })

                this.buAutocomplete.retrieve(this.sottoprogetto_model.business_unit_id)
                return progettiManager.progetto(this.sottoprogetto_model.progetto_id)

            }).then((response) => {
                this.progetto_model = response.data
                if (this.progetto_model.azienda_gruppo_id) {
                    this.buAutocomplete.callBinds = [this.progetto_model.azienda_gruppo_id]
                    this.buAutocomplete.search('', 0)
                }

                if (this.progetto_model.promo) {
                    this.tipoOperazioniAutocomplete.addAjaxParam('s', 1)
                }

                this.tipoOperazioniAutocomplete.retrieve(this.sottoprogetto_model.tipo_operazione_id)

                sottoProgettiManager.accounts(this.id).then((response) => {
                    this.accountAutocomplete.selection = response.data
                    this.accountAutocomplete.options = response.data
                })

                sottoProgettiManager.projectManagers(this.id).then((response) => {
                    this.projectManagersAutocomplete.selection = response.data
                    this.projectManagersAutocomplete.options = response.data
                })

                sottoProgettiManager.direttoriProduzione(this.id).then((response) => {
                    this.direttoriProduzioneAutocomplete.selection = response.data
                    this.direttoriProduzioneAutocomplete.options = response.data
                })
            })
        }
    }

    empty() {
        this.sottoprogetto_model.titolo = null
        this.sottoprogetto_model.anno = null
        this.sottoprogetto_model.descrizione = null
        this.sottoprogetto_model.data_inizio = null
        this.sottoprogetto_model.data_fine = null
        this.sottoprogetto_model.business_unit_id = null
        this.sottoprogetto_model.data_consegna_offerta = null
        this.sottoprogetto_model.note = null
        this.sottoprogetto_model.budget_preventivo = null
        this.sottoprogetto_model.accounts.splice(0)
        this.sottoprogetto_model.project_managers.splice(0)
        this.sottoprogetto_model.direttori_produzione.splice(0)
        this.buAutocomplete.empty()
        this.accountAutocomplete.empty()
        this.projectManagersAutocomplete.empty()
        this.direttoriProduzioneAutocomplete.empty()
    }

    get canSetIntragruppo() {
        return this.create || this.hasPermission('set sottoprogetto_intragruppo');
    }

    @Watch('buAutocomplete.selection')
    bu(new_value: any, old: any) {
        if (this.cliente_id) {
            clientiManager.accountsAzienda(this.cliente_id, {params: {bu: new_value?.id}}).then((response) => {
                this.accounts_cliente = response.data
            })
        }
        this.sottoprogetto_model.business_unit_id = new_value?.id
        this.tipoOperazioniAutocomplete.emptyAll()
        this.tipoOperazioniAutocomplete.addAjaxParam('bu', this.sottoprogetto_model.business_unit_id)
        this.tipoOperazioniAutocomplete.search('', 0)
        // this.accountAutocomplete.emptyAll()
        // this.accountAutocomplete.addAjaxParam('bu', this.sottoprogetto_model.business_unit_id)
        // this.accountAutocomplete.search('', 0)
        // this.projectManagersAutocomplete.emptyAll()
        // this.projectManagersAutocomplete.addAjaxParam('bu', this.sottoprogetto_model.business_unit_id)
        //nel caso in cui abbia selezionato PA come bu allora devo far vedere anche i pm di roma, per evitare di mettere
        //il codice hardcodato passo un parametro in piu extra
        // this.projectManagersAutocomplete.addAjaxParam('extra', 1)
        // this.projectManagersAutocomplete.search('', 0)
        // this.direttoriProduzioneAutocomplete.emptyAll()
        // this.direttoriProduzioneAutocomplete.addAjaxParam('bu', this.sottoprogetto_model.business_unit_id)
        // this.direttoriProduzioneAutocomplete.search('', 0)
    }

    @Watch('defaultValue.azienda_gruppo_id')
    defaultValueChange(new_value: any, old: any) {
        if (new_value) {
            this.buAutocomplete.callBinds = [new_value]
            this.buAutocomplete.search('', 0)
        }
    }

    @Watch('progetto_is_promo')
    defaultChange(new_value: any, old: any) {
        if (new_value) {
            this.tipoOperazioniAutocomplete.addAjaxParam('s', 1)
            this.tipoOperazioniAutocomplete.search('', 0)
        }
    }

    @Watch('tipo_iva_selection')
    tipo_iva(new_value: any, old: any) {
        this.sottoprogetto_model.tipo_iva = new_value?.id
    }

    @Watch('biglietteria_selection')
    biglietteria(new_value: any, old: any) {
        this.sottoprogetto_model.biglietteria = new_value ? new_value.id : null
    }

    @Watch('gara_selection')
    gara(new_value: any, old: any) {
        this.sottoprogetto_model.gara = new_value ? new_value.id : null
    }

    @Watch('periodicita_selection')
    periodicita(new_value: any, old: any) {
        this.sottoprogetto_model.periodicita = new_value ? new_value.id : null
    }

    @Watch('segreteria_selection')
    segreteria(new_value: any, old: any) {
        this.sottoprogetto_model.segreteria = new_value ? new_value.id : null
    }

    @Watch('tipo_evento_selection')
    tipo_evento(new_value: any, old: any) {
        this.sottoprogetto_model.tipo_evento = new_value ? new_value.id : null
    }

    @Watch('paeseAutocomplete.selection')
    paese(new_value: any, old: any) {
        this.sottoprogetto_model.paese_id = new_value ? new_value.id : null
    }

    @Watch('accountAutocomplete.selection')
    account(new_value: any, old: any) {
        this.sottoprogetto_model.accounts = new_value.map((e: any) => e.id)
    }

    @Watch('sottoprogettoAutocomplete.selection')
    intragruppo(new_value: any, old: any) {
        this.sottoprogetto_model.intragruppo_padre_id = new_value ? new_value.id : null
    }

    @Watch('tipoOperazioniAutocomplete.selection')
    tipoOperazione(new_value: any, old: any) {
        this.sottoprogetto_model.tipo_operazione_id = new_value ? new_value.id : null
    }

    @Watch('projectManagersAutocomplete.selection')
    pm(new_value: any, old: any) {
        this.sottoprogetto_model.project_managers = new_value.map((e: any) => e.id)
    }

    @Watch('direttoriProduzioneAutocomplete.selection')
    dp(new_value: any, old: any) {
        this.sottoprogetto_model.direttori_produzione = new_value.map((e: any) => e.id)
    }

    // setModelFile() {
    //     this.sottoprogetto_model.brief_files = this.sottoprogettoFiles.map(e => e.id).concat(this.uploaded_files.map(e => e.id))
    // }

    creaSottoProgetto() {
        this.loading = true
        // this.setModelFile()
        if (this.create) {
            progettiManager.sottoprogettoCreate(this.progetto_id, this.sottoprogetto_model).then((res) => {
                this.$emit('saved', res.data)
            }).then(() => {
                this.empty()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            }).finally(() => {
                this.loading = false
            })
        } else {
            sottoProgettiManager.sottoprogettoUpdate(this.id, this.sottoprogetto_model).then((res) => {
                this.$emit('saved', res.data)
            }).then(() => {
                this.empty()
            }).catch((res) => {
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            }).finally(() => {
                this.loading = false
            })
        }
    }

    get requiredPeriodicita() {
        return this.buAutocomplete.selection && ['AD', 'DG', 'SL'].includes(this.buAutocomplete.selection.label)
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
